var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.13359 3.13359 0 7 0C10.8664 0 14 3.13359 14 7C14 10.8664 10.8664 14 7 14C3.13359 14 0 10.8664 0 7ZM1.3125 7C1.3125 10.1361 3.86367 12.6875 7 12.6875C10.1363 12.6875 12.6875 10.1361 12.6875 7C12.6875 3.86395 10.1363 1.3125 7 1.3125C3.86367 1.3125 1.3125 3.86395 1.3125 7ZM4.10535 7.98413C4.64893 7.98413 5.0896 7.54347 5.0896 6.99988C5.0896 6.45629 4.64893 6.01562 4.10535 6.01562C3.56176 6.01562 3.12109 6.45629 3.12109 6.99988C3.12109 7.54347 3.56176 7.98413 4.10535 7.98413ZM7.98425 7C7.98425 7.54359 7.54359 7.98425 7 7.98425C6.45641 7.98425 6.01575 7.54359 6.01575 7C6.01575 6.45641 6.45641 6.01575 7 6.01575C7.54359 6.01575 7.98425 6.45641 7.98425 7ZM9.89441 7.98413C10.438 7.98413 10.8787 7.54347 10.8787 6.99988C10.8787 6.45629 10.438 6.01562 9.89441 6.01562C9.35082 6.01562 8.91016 6.45629 8.91016 6.99988C8.91016 7.54347 9.35082 7.98413 9.89441 7.98413Z",
    fill: "#FE815F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPending);
export default __webpack_public_path__ + "static/media/status-pending.5dee849b26e2fe1f52c10472463b207a.svg";
export { ForwardRef as ReactComponent };